'use client'

/**
 * サーバー側でだけ確定できる機能フラグ（環境変数）を、クライアント側の条件表示へ届ける。
 *
 * `app/layout.tsx`（Server Component）が `process.env` を読んで唯一の入力元として渡す。
 * クライアント側で直接 `process.env` を読まないのは、ビルド時に NEXT_PUBLIC_ 接頭辞なしの
 * 値はバンドルへ入らず undefined になり、フラグが常にOFFへフォールバックして混乱するため。
 *
 * Providerが無い場合は安全側（false=機能を隠す）にフォールバックする
 * （テスト・Storybook等でProviderを省略しても、機能が誤って露出しないようにするため）。
 */
import { createContext, useContext } from 'react'

export interface FeatureFlags {
  /** CARDDAV_SYNC_ENABLED。OFFのときは導線を出さない（画面自体もServer Component側でnotFound()）。 */
  carddavSyncEnabled: boolean
}

const DEFAULT_FLAGS: FeatureFlags = {
  carddavSyncEnabled: false,
}

const FeatureFlagsContext = createContext<FeatureFlags>(DEFAULT_FLAGS)

export function FeatureFlagsProvider({
  children,
  ...flags
}: { children: React.ReactNode } & Partial<FeatureFlags>) {
  const value: FeatureFlags = { ...DEFAULT_FLAGS, ...flags }
  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>
}

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagsContext)
}
